import React from "react";
import ReactDOM from "react-dom";
import "./stylesheets/main.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import ConfigLoader from "./components/ConfigLoader";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigLoader>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigLoader>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
